// extracted by mini-css-extract-plugin
export default {"img_wrapper":"Image_img_wrapper__yLu6n","empty":"Image_empty__ZydBX","theme__default":"Image_theme__default__E8IZX","theme__orange":"Image_theme__orange__WBqBT"};